/**
 * 読み上げテキスト内のプレースホルダーを実際の値に置き換える
 * @param {string} text - プレースホルダーを含むテキスト
 * @param {object} levelData - 現在のレベルのデータ
 * @param {Array<object>} columns - ストラクチャーの列定義
 * @param {object} appConfig - アプリケーションの設定（requiredLevelKeyなどの判定用）
 * @returns {string} - 置き換え後のテキスト。値が見つからない場合は空文字。
 */
export const replacePlaceholders = (text, levelData, columns, appConfig) => {
  if (!text || !levelData || !columns || !appConfig) return '';

  let replacedText = text;
  const placeholders = text.match(/\[([^\]]+)\]/g);

  if (!placeholders) {
    return text;
  }

  for (const placeholder of placeholders) {
    const key = placeholder.slice(1, -1);
    let value;

    // レベル番号のプレースホルダー判定
    if (key.toLowerCase() === appConfig.requiredLevelKey?.toLowerCase()) {
      value = levelData.level;
    } else {
      // カラム名に一致する値を探す
      const columnExists = columns.some(c => c.label === key);
      if (!columnExists) {
        // カラムが存在しないプレースホルダーが含まれている場合は、読み上げを中断（誤った発話を防ぐため）
        return '';
      }
      value = levelData[key];
    }

    if (value === undefined || value === null) {
      return '';
    }

    replacedText = replacedText.replace(placeholder, value);
  }

  return replacedText;
};
